<!-- 안전리더십 > 안전리더십 관리 상세 > 단계 상세설정 팝업 -->
<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="127rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.detailedSettings')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text>
          <div class="form-group col-ty">
            <!--form-row-->
            <div class="form-row ty04">
              <div class="txt-tit ty02">{{t('message.stepName')}}</div>
              <div class="row">
                <c-Input :placeholder="t('message.enterTitle')" v-model="viewInfo.taskTitle" class="size06" :name="'taskTitle'"/>
              </div>
            </div>
            <!--form-row-->
            <div class="form-row ty04">
              <div class="txt-tit ty02">{{t('message.stepDescription')}}</div>
              <div class="row">
                <c-Input :placeholder="t('message.detailDescriptionPlaceholder')" v-model="viewInfo.taskDescription" class="size06" :name="'taskDescription'"/>
              </div>
            </div>
          </div>
          <div class="sort-group ty02">
            <div class="sort-row">
              <div class="wl">
                <div class="txt04">{{t('message.safetyLeadershipTaskSetting')}}</div>
              </div>
              <div class="wr">
                <c-btn01 :btnText="t('message.addTask')" class="sm" @click="onClickAdd"/>
                <c-btn02 :btnText="t('message.evaluationMerge')" class="sm" @click="onClickMerge"/>
                <c-btn02 :btnText="t('message.evaluationSplit')" class="sm" @click="onClickUnMerge"/>
              </div>
            </div>
          </div>
          <div class="sortable-group02">
            <div class="sortable-header">
              <div class="col" v-html="t('message.displayOrderLeadership')"></div>
              <div class="col" v-html="t('message.title')"></div>
              <div class="col" v-html="t('message.reflectToPerformance')"></div>
              <div class="col" v-html="t('message.allowDuplicateSubmission')"></div>
              <div class="col" v-html="t('message.evaluationType')"></div>
              <div class="col" v-html="t('message.evaluationCriteria')"></div>
              <div class="col" v-html="t('message.periodLeadership')"></div>
              <div class="col" v-html="t('message.countLeadership')"></div>
              <div class="col" v-html="t('message.evaluationWeight')"></div>
              <div class="col" v-html="t('message.mergedEvaluationWeight')"></div>
              <div class="col" v-html="t('message.detailSetting')"></div>
              <div class="col" v-html="t('message.delete')"></div>
              <div class="col" v-html="t('message.merge')" v-if="viewInfo.contentList?.length > 1"></div>
            </div>
            <draggable
              v-model="viewInfo.contentList"
              item-key="idx"
              tag="div"
              class="sortable-cont"
              animation="200"
              @end="onChange"
            >
              <template #item="{element, index}">
                <div class="draggable" :key="element.idx" :data-idx="element.idx">
                  <div class="row" v-if="utils.isEmpty(element.subContentList) || element.subContentList?.length == 0">
                    <div class="col" aria-hidden="true">
                      <img src="../../assets/img/format-align-justify.svg" alt="">
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input :placeholder="t('message.title')" class="size06" v-model="element.contentTitle" :name="`contentList[${element.idx}].contentTitle`"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="check-group">
                        <v-checkbox v-model="element.reportYn" @click="onCheckType('report', element, $event)" true-value="Y" false-value="N"></v-checkbox>
                      </div>
                    </div>
                    <div class="col">
                      <div class="check-group">
                        <v-checkbox v-model="element.duplicateYn" true-value="Y" false-value="N" :disabled="element.contentType == '1'||element.contentType == '2'"></v-checkbox>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <Select v-bind="contentTypeSelect" v-model="element.contentType" @update:modelValue="(value) => onChangeType(value, 'content', element)" class="size06"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <Select v-bind="element.contentType=='1'?criteriaFreeTypeSelect:element.contentType=='2'?criteriaQuizTypeSelect:criteriaMonitorTypeSelect" v-model="element.criteriaType" :disabled="element.reportYn != 'Y'" class="size06"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <Select v-bind="periodTypeSelect" v-model="element.periodType" class="size06"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input02 class="size06" v-model="element.periodCnt" :name="'periodCnt'+element.idx" @keyup="onClickRatio('period',element,$event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input02 class="size06" v-model="element.evaluationRatio" :name="'evaluationRatio'+element.idx" :disabled="element.reportYn != 'Y'" @keyup="onClickRatio('normal',element,$event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input02 class="size06" v-model="element.mergeRatio" :name="'mergeRatio'+element.idx" :disabled="true" @keyup="onClickRatio('merge',element,$event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <BtnIcon class="btn-ico-set" @click="onClickSetting(element)"/>
                    </div>
                    <div class="col">
                      <BtnIcon class="btn-ico-delete" @click="onClickDelete(element)"/>
                    </div>
                    <div class="col" v-if="viewInfo.contentList?.length > 1">
                      <div class="check-group">
                        <v-checkbox v-model="element.mergeCheck" true-value="Y" false-value="N"></v-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="element.subContentList?.length > 0" v-for="(element2, index2) in element.subContentList">
                    <div class="col" aria-hidden="true">
                      <img v-if="index2==0" src="../../assets/img/format-align-justify.svg" alt="">
                    </div>
                    <div class="col">
                      <div class="form-group" v-if="index2==0">
                        <c-Input :placeholder="t('message.title')" class="size06" v-model="element2.contentTitle" :name="`contentList[${element.idx}].subContentList[${element2.idx}].contentTitle`"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="check-group">
                        <v-checkbox v-model="element2.reportYn" @click="onCheckType('report', element2, $event)" true-value="Y" false-value="N"></v-checkbox>
                      </div>
                    </div>
                    <div class="col">
                      <div class="check-group">
                        <v-checkbox v-model="element2.duplicateYn" true-value="Y" false-value="N"></v-checkbox>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <Select v-bind="contentTypeSelect" v-model="element2.contentType" @update:modelValue="(value) => onChangeType(value, 'content', element2)" :disabled="element2.reportYn != 'Y'" class="size06"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <Select v-bind="element2.contentType=='1'?criteriaFreeTypeSelect:element2.contentType=='2'?criteriaQuizTypeSelect:criteriaMonitorTypeSelect" v-model="element2.criteriaType" :disabled="element2.reportYn != 'Y'" class="size06"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <Select v-bind="periodTypeSelect" v-model="element2.periodType" class="size06"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input02 class="size06" v-model="element2.periodCnt" :name="'periodCnt'+element2.idx" @keyup="onClickRatio('period',element,$event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input02 class="size06" v-model="element2.evaluationRatio" :name="'evaluationRatio'+element2.idx" :disabled="element2.reportYn != 'Y'" @keyup="onClickRatio('normal',element2,$event)" v-if="index2==0"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <c-Input02 class="size06" v-model="element2.mergeRatio" :name="`mergeRatio_${element.idx}_${element2.idx}`" :disabled="element2.reportYn != 'Y'" @keyup="onClickRatio('merge',element2,$event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <BtnIcon class="btn-ico-set" @click="onClickSetting(element2)"/>
                    </div>
                    <div class="col">
                      <BtnIcon class="btn-ico-delete" @click="onClickDelete(element2)"/>
                    </div>
                    <div class="col" v-if="viewInfo.contentList?.length > 1">
                      <div class="check-group" v-if="index2==0">
                        <v-checkbox v-model="element2.mergeCheck" true-value="Y" false-value="N"></v-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
            <div class="sortable-footer">
              <div class="col">{{t('message.totalLeadership')}}</div>
              <div class="col">{{t('message.totalEvaluationWeight')}} <span>{{ totalScore }}</span></div>
            </div>
          </div>

        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end">
          <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
          <c-btn01 :btnText="t('message.save')" @click="onClickSave"/>
        </v-card-actions>
      </v-card>
      <!--popup: 상세설정:셀프모니터링-->
      <DialogSafetyDetailSetTy1 v-model="DialogSafetyDetailSetTy1Model"
                                @close="DialogSafetyDetailSetTy1Model=false"
      />
      <!--popup: 상세설정:퀴즈형식-->
      <DialogSafetyDetailSetTy2 v-model="DialogSafetyDetailSetTy2Model"
                                @close="DialogSafetyDetailSetTy2Model=false"
      />
      <!--popup: 상세설정:자유형식-->
      <DialogSafetyDetailSetTy3 v-model="DialogSafetyDetailSetTy3Model"
                                @close="DialogSafetyDetailSetTy3Model=false"
      />
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import {ref, onMounted, watch} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {useForm} from "vee-validate";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import draggable from 'vuedraggable'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const dialog = defineModel()
const emit = defineEmits(['close', 'confirm'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  taskTitle: yup.string().required(() => t('message.requiredField')),
  taskDescription: yup.string().required(() => t('message.requiredField')),
  contentList: yup.array().of(
    yup.object({
      contentTitle: yup
        .string()
        .required(() => t('message.requiredField'))
    })
  )
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const DialogSafetyDetailSetTy1Model = ref(false)
const DialogSafetyDetailSetTy2Model = ref(false)
const DialogSafetyDetailSetTy3Model = ref(false)
const viewInfo:any = ref({})
const totalScore = ref(0)

//ui
const contentTypeSelect = {items: [{name: t('message.freeForm'), value: '1'},{name: t('message.quiz'), value: '2'},{name: t('message.selfMonitoring'), value: '3'},{name: t('message.peerMonitoring'), value: '4'}]}
const criteriaQuizTypeSelect = {items: [{name: t('message.isCompleted'), value: '1'},{name: t('message.quizScore'), value: '2'}]}
const criteriaMonitorTypeSelect = {items: [{name: t('message.isCompleted'), value: '1'},{name: t('message.safetyBehaviorRate'), value: '3'}]}
const criteriaFreeTypeSelect = {items: [{name: t('message.isOpened'), value: '1'},{name: t('message.attachSubmissionFile'), value: '4'}]}
const periodTypeSelect = {items: [{name: '1'+t('message.week'), value: '1'}, {name: '2'+t('message.week'), value: '2'}, {name: t('message.month'), value: '10'}, {name: t('message.quarter'), value: '11'}, {name: t('message.halfYear'), value: '12'}, {name: t('message.year3'), value: '13'}]}

//hook
onUpdated (() => {
  if (!dialog.value)
    return

  getLeadershipTask()
})

const getLeadershipTask = ()=>{
  //선택된 리더십 task
  let leadershipTask:any = storeRef.selectedTask.value
  let leadershipInfo:any = storeRef.leadershipInfo.value
  LeadershipService.getLeadershipTask({idx:leadershipTask.idx, leadershipIdx:leadershipInfo.idx}).then(
    (response) => {
      //트리->트리화
      const nestedInfo = {...response.result, contentList:nestList(response.result.contentList)}
      viewInfo.value = nestedInfo
      _.forEach(viewInfo.value.contentList, item=>{item.periodCnt = item.periodCnt == 0 ? 1 : item.periodCnt; item.reportYn = item.reportYn??'Y'; item.reportYn = viewInfo.value.reportYn=='N'?'N':item.reportYn;})
      totalScore.value = getScore()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

//content추가
const onClickAdd = ()=>{
  //선택된 리더십 task
  let taskItem:any = storeRef.selectedTask.value
  let params = {
    leadershipIdx: taskItem.leadershipIdx,
    taskIdx: taskItem.idx
  }
  if(utils.isEmpty(taskItem.leadershipIdx)){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
    return
  }
  LeadershipService.insertLeadershipContent(params).then(
    (response) => {
      if (response.success) {
        viewInfo.value.contentList.push({idx:response.result.idx, contentType:'1',criteriaType:'1',periodType:'1', reportYn:'Y'})
      } else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickSetting = async (item)=>{
  //선택된 리더십 content
  const contentUpdate = await updateLeadershipContent(item)
  if(contentUpdate) {
    storeRef.selectedContent.value = item
    if (item.contentType == '1')
      DialogSafetyDetailSetTy3Model.value = true
    else if (item.contentType == '2')
      DialogSafetyDetailSetTy2Model.value = true
    else if (item.contentType == '3' || item.contentType == '4')
      DialogSafetyDetailSetTy1Model.value = true
  }
  else {
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
}

const onClickDelete = (item)=>{
  let params = {
    idx: item.idx,
    delYn: "Y"
  }
  LeadershipService.insertLeadershipContent(params).then(
    (response) => {
      if (response.success) {
        //getLeadershipTask()
        _.remove(viewInfo.value.contentList, item)
      } else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const updateLeadershipContent = async (item)=>{
  let params = {
    idx: item.idx,
    reportYn: item.reportYn,
    contentType: item.contentType,
    criteriaType: item.criteriaType,
  }
  try{
    const response = await LeadershipService.insertLeadershipContent(params)
    if(response.success)
      return true
    else
      return false
  }
  catch(error){
    return false
  }
}

const onClickMerge = ()=>{
  const mergedList = _.filter(viewInfo.value.contentList, { mergeCheck: "Y" })
  if (mergedList.length <= 1)
    return
  const parent = _.first(mergedList)

  // 병합 대상 전부 -> subContentList 구성 (parentIdx 넣기)
  const subList = mergedList.map((item, index) => ({...item, parentIdx: parent.idx, mergeCheck: "N", evaluationRatio: index === 0 ? item.evaluationRatio : 0, mergeRatio:0}))
  // parent에 subContentList 설정
  parent.subContentList = subList
  // 병합 대상 중 첫 번째 외 모두 제거
  const toRemove = mergedList.slice(1)
  _.remove(viewInfo.value.contentList, item =>_.some(toRemove, { idx: item.idx }))

  // mergeCheck 초기화
  viewInfo.value.contentList = viewInfo.value.contentList.map(item => ({...item, mergeCheck: "N"}))
  // 점수 초기화
  totalScore.value = getScore()
}

const onClickUnMerge = ()=>{
  const newList = []
  viewInfo.value.contentList.forEach(item => {
    // 병합된 항목이면, 자식만 꺼내고 부모는 제거
    if (Array.isArray(item.subContentList) && _.some(item.subContentList, {mergeCheck: 'Y'})) {
      const flattenedChildren = item.subContentList.map(child => _.omit(child, ['parentIdx']))
      newList.push(...flattenedChildren);
    }
    else { //그대로 유지
      newList.push(item)
    }
  })

  // 교체 (반응성 유지)
  viewInfo.value.contentList = newList.map(item => ({...item,mergeCheck: "N"}))
  // 점수 초기화
  totalScore.value = getScore()
}

//저장
const onClickSave = async ()=>{
  const result = await validate() // 전체 필드 검증 실행
  if(!result.valid)
    return

  //횟수 체크
  const periodCntList = _.filter(viewInfo.value.contentList, {'reportYn':'Y', 'periodCnt':0})
  if(periodCntList.length > 0){
    snackText.value = t('message.minEvaluationAlert')
    snackbar.value = true
    return
  }

  //총 평가가중치 체크
  const reportList = _.filter(viewInfo.value.contentList, {'reportYn':'Y'})
  totalScore.value = getScore()
  if(totalScore.value != 100 && reportList.length > 0){
    snackText.value = t('message.evaluationWeight100Alert')
    snackbar.value = true
    return
  }

  //총 서브평가가중치 체크
  let totalMergeCheck = false
  viewInfo.value.contentList.forEach(item => {
    if (Array.isArray(item.subContentList) && item.subContentList.length > 0) {
      const totalMergeRatio = _.sumBy(item.subContentList, sub => parseFloat(sub.mergeRatio || "0"));
      if(totalMergeRatio != 100)
        totalMergeCheck = true
    }
  })
  if(totalMergeCheck){
    snackText.value = t('message.mergedEvaluationWeight100Alert')
    snackbar.value = true
    return
  }
  //트리->평탄화
  const params = {...viewInfo.value, contentList:flattenList(viewInfo.value.contentList)}
  LeadershipService.insertLeadershipTask(params).then( //이미 생성되어 있음.. 무조건 update 탄다
    (response) => {
      if (response.success) {
        emit('confirm', viewInfo.value)
        dialog.value = false
      } else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onCheckType = (type, item, event)=>{
  if(type == 'report'){
    if(event.target.checked){
      item.reportYn = 'Y'
    }
    else {
      item.reportYn = 'N'
    }
  }
  itemProc(item)
}

const onChangeType = (selectObj, type, item)=>{
  if(type == 'content'){
    if(item.contentType == '1')
      item.criteriaType = '1'
    else if(item.contentType == '2')
      item.criteriaType = '2'
    else if(item.contentType == '3' || item.contentType == '4')
      item.criteriaType = '3'
  }
}

const itemProc = (item)=>{
  if(item.reportYn == 'N'){
    item.evaluationRatio = 0
    item.mergeRatio = 0
  }
}

const getScore=()=>{
  let total = 0;
  viewInfo.value.contentList.forEach(item => {
    if (Array.isArray(item.subContentList) && item.subContentList.length > 0) {
      // subContentList 있는 경우 → 그 안에서만 계산
      total += _.sumBy(item.subContentList, (sub,index) =>sub.reportYn === "Y" ? parseInt(sub.evaluationRatio || 0) : 0)
    } else {
      // subContentList 없으면 1뎁스 자체 계산
      if (item.reportYn === "Y")
        total += parseInt(item.evaluationRatio || 0)
    }
  })

  return total
}

const onClickRatio = (type,item,event)=>{
  event.target.value = event.target.value.replace(/\D/g, '')
  if(type == 'normal'){
    totalScore.value = getScore()
  }
  else if(type == 'merge'){

  }
}

const flattenList = (nestedList) => {
  const flat = []
  nestedList.forEach(item => {
    const { subContentList } = item
    if (Array.isArray(subContentList) && subContentList.length > 0) {
      subContentList.forEach((child,index) => {
        // 부모 제거하고 자식만 추가
        flat.push({ ...child, parentIdx: item.idx, mergeYn:'Y', evaluationRatio:index===0?child.evaluationRatio:0 })
      })
    } else {
      // 자식이 없으면 부모를 그대로 추가
      flat.push({ ...item, parentIdx: null, mergeYn:'N' })
    }
  })

  return flat
}

//todo 그룹도 검증필요
const nestList = (flatList) => {
  /*
  const grouped = _.groupBy(flatList, item => item.parentIdx || item.idx)
  const nested = []

  for (const groupKey in grouped) {
    const group = grouped[groupKey]
    if (group.length === 1) {
      // 단일 항목이면 그대로 push
      nested.push({ ...group[0] })
    } else {
      const parent = group[0]
      nested.push({
        ..._.omit(parent, ['parentIdx']), // 부모 정보로 보여주되
        subContentList: group.map(item => ({ ...item })) // 부모 + 자식 전체 포함
      })
    }
  }

  return nested
   */
  const grouped = _.groupBy(flatList, item => item.parentIdx || item.idx)
  const nested = []
  const added = new Set() // 중복 push 방지

  // 🔥 flatList 순서 기준으로만 처리
  flatList.forEach(item => {
    const key = item.parentIdx || item.idx
    if (added.has(key)) return
    const group = grouped[key]
    if (group.length === 1) {
      nested.push({ ...group[0] })
    } else {
      const parent = group.find(g => !g.parentIdx) || group[0]
      nested.push({
        ..._.omit(parent, ['parentIdx']),
        subContentList: group.map(g => ({ ...g }))
      })
    }
    added.add(key)
  })

  return nested
}

const onChange = () => {
  console.log('최종 순서:', viewInfo.value.contentList.map(v => v.idx))
}

//sortable 리스트 순서변경 -> 사용안함
/*
function onUpdateList(evt) {
  const oldIndex = evt.oldIndex;
  const newIndex = evt.newIndex;
  console.log('before:'+viewInfo.value.contentList)
  if (typeof oldIndex === 'number' && typeof newIndex === 'number')
    moveArray(viewInfo.value.contentList, oldIndex, newIndex)

  console.log('after:'+viewInfo.value.contentList)
}

function moveArray(arr, from, to) {
  if (from === to) return;
  const item = arr.splice(from, 1)[0];
  arr.splice(to, 0, item);
}
 */

</script>


<style lang="scss" scoped>
.sortable-group02{
  .sortable-header ,.sortable-cont .draggable{
    .col:nth-child(1){flex-grow:0;width:5%;}
    .col:nth-child(2){justify-content:flex-start;text-align:left}
    .col:nth-child(3){flex-grow:0;width:6%;}
    .col:nth-child(4){flex-grow:0;width:6%;}
    .col:nth-child(5){flex-grow:0;width:12%;}
    .col:nth-child(6){flex-grow:0;width:12%;}
    .col:nth-child(7){flex-grow:0;width:8%;}
    .col:nth-child(8){flex-grow:0;width:6%;}
    .col:nth-child(9){flex-grow:0;width:6%;}
    .col:nth-child(10){flex-grow:0;width:6%;}
    .col:nth-child(11){flex-grow:0;width:5%;}
    .col:nth-child(12){flex-grow:0;width:5%;}
    .col:nth-child(13){flex-grow:0;width:5%;}
  }
  .sortable-footer{
    .col:nth-child(1){flex-grow:0;width:16%;}
    .col:nth-child(2){flex-grow:0;width:38%;}
  }
}
</style>
